import {Component, OnInit} from "@angular/core";
import {DialogComponent} from "../../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";

@Component({
    selector: 'db-ssl-failed-dialog',
    templateUrl: 'ssl-failed-dialog.component.html',
    styleUrls: ['ssl-failed-dialog.component.scss'],
    standalone: false
})
export class SSlFailedDialogComponent extends DialogComponent<null, boolean> implements OnInit {

  public steps: any[];


  constructor(
    private _dialogService: DialogService,
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.steps = [
      {
        img: './../../assets/images/ssl-failed/zip_download.png',
        title: 'Step 1',
        desc: 'Log in to the Cloudflare dashboard, select the website, and go to the SSL/TLS tab.'
      },
      {
        img: './../../assets/images/ssl-failed/activate_plugin.png',
        title: 'Step 2',
        desc: 'Set encryption mode to Off.'
      },
      {
        img: './../../assets/images/ssl-failed/generate_free.png',
        title: 'Step 3',
        desc: 'Generate a free certificate from the 10Web dashboard again.'
      },
      {
        img: './../../assets/images/ssl-failed/go_to_cloudflare.png',
        title: 'Step 4',
        desc: 'Go back to cloudflare and set encryption mode back to Full.'
      },
    ];

  }
}
